import Link from "next/link";
import React from "react";
import { useStoreContext } from "../../contexts/StoreDataContext";
import { trackEvent } from "../../utils/analytics";
import { EVENTS } from "../../utils/analyticsConfig";

export default function RegularFooter() {
  const context = useStoreContext();
  const storeData = context?.storeData;

  const navigateToHome = () => {
    const url = `https://dm2buy.app.link/apps?utm_source=footer&utm_campaign=${storeData.subdomain}`;
    trackEvent(EVENTS.FOOTER_CTA, {
      referrer: storeData.subdomain,
    });
    window.open(url, "_blank").focus();
  };

  const legalInfo = storeData?.legalInfo;
  const terms = legalInfo?.terms;
  const privacy = legalInfo?.privacy;
  const about = legalInfo?.about;
  const policy = legalInfo?.policy;
  const care = legalInfo?.care;
  const size = legalInfo?.size;

  return (
    <footer className="mt-20 flex w-full flex-col px-5 pb-8">
      <div
        className="flex cursor-pointer flex-col items-center text-2xl font-bold tracking-wide text-[#1c3142]"
        onClick={navigateToHome}
      >
        dm2buy
      </div>

      <div className="flex flex-wrap justify-center text-sm text-gray-700">
        {policy && <Link href="/policy">Store Policy</Link>}
        {care && <Link href="/care">Product Care</Link>}
        {size && <Link href="/size">Size</Link>}
        {terms && <Link href="/terms">Terms</Link>}
        <Link href="/returns">Shipping & Return</Link>
        {privacy && <Link href="/privacy">Privacy</Link>}
        <Link href="/contact">Contact Us</Link>
        {about && <Link href="/about">About</Link>}
      </div>
    </footer>
  );
}
